let checkNewsLetterCampaign = true;
window.isSwellSetup = false;
(function() {
    $(document).ready(function() {
        SwellConfig.Referral.initializeReferralCode(".swell-referral-content-main");
        var clipboard = new ClipboardJS('#copy-link-button');
        var timeInterval = setInterval(function() {
            if (!window.isSwellSetup && typeof(spapi) != "undefined" && spapi.authenticated != undefined) {
                window.isSwellSetup = true;
                clearInterval(timeInterval);
                setTimeout(function(){
                    SwellConfig.Referral.initializeReferralProcess();
                    SwellConfig.Referral.initializeReferral();
                    if($(".swell-post-checkout").length > 0) {
                        $(".swell-post-checkout").css("display","flex");
                        $(".swell-post-checkout .swell-post-checkout-holder").addClass("is-active");
                    }
                    SwellConfig.Referral.populateRedemptionOffers();
                    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
                    SwellConfig.Redemption.appendRedemption(".swell-redemption-option-list");
                    SwellConfig.Campaign.customCampaign(".swell-campaign-list");
                    SwellConfig.Campaign.campaignHover();
                    SwellConfig.Campaign.completedCampaigns();
                    if($(".swell-tier-list").length>0){
                        SwellConfig.Tier.initializeCustomTierProperties();
                        SwellConfig.Tier.initializeTiers(".swell-tier-list");
                        SwellConfig.Tier.setupSlick(".swell-tier-list");
                    }
                    $(".swell-lds-holder").remove();
                    if(spapi.authenticated) {
                        swellAPI.refreshEmbeds();
                    }
                }, 3000);
            }
        }, 1000);
        $("body").on("click", ".swell-popup-close", function() {
            $(".swell-post-checkout .swell-post-checkout-holder").removeClass("is-active");
            $(".swell-post-checkout").hide();
        });
        $("body").on("click","#newsLetterPopupSubmit", function() {
            $(this).html("");
            $(this).append('<div class="swell-lds-dual-ring"></div>');
            var existingEmailField = $("#newsLetterInputFeild");
            var email = existingEmailField.val();
            var onNewsletterSuccess = function()
            {
                $("#newsLetterPopupSubmit").css("display","none");
                $("#newsLetterInputFeild").css("display","none");
                $("#newsLetterPopup .yui3-cssreset").addClass("finish");
                $("#swell-popup-items-container-custom .main-heading-title").addClass("finish");
                $("#swell-popup-items-container-custom .main-heading").addClass("finish");
                $("#swell-popup-items-container-custom .main-heading").html("Thank You!");
                $("#swell-popup-items-container-custom .main-heading-title").html("10 points have been added to your account!");
                checkNewsLetterCampaign = false;
                spapi.refreshCustomerDetails();
            }
            var onError = function () {
                $("#swell-popup-items-container-custom #newsLetterInputFeild").before("<p class='email-capture-error'>Please Enter Correct Email!</p>");
            }
            swellAPI.captureNewsletterSignup(email, onNewsletterSuccess);
        });
        $("body").on("click","#swellNewsLetter", function() {
            if(spapi.authenticated) {
                if(checkNewsLetterCampaign) {
                    $("#newsLetterPopup").css("display","flex");
                } else {
                    $("#newsLetterPopupSubmit").css("display","none");
                    $("#newsLetterInputFeild").css("display","none");
                    $("#newsLetterPopup .yui3-cssreset").addClass("finish");
                    $("#swell-popup-items-container-custom .main-heading-title").addClass("finish");
                    $("#swell-popup-items-container-custom .main-heading").addClass("finish");
                    $("#swell-popup-items-container-custom .main-heading").html("Thank You!");
                    $("#swell-popup-items-container-custom .main-heading-title").html("You've already completed it!");
                }
                $("#newsLetterPopup").css("display","flex");
            }
        });
        $("body").on("click","#swell-popup-close-x", function() {
            $("#newsLetterPopup").css("display","none");
        });
    });
}).call(this);

//refer
(function ()
{
    window.SwellConfig = window.SwellConfig ||
        {};
    SwellConfig.Referral = {
        opts:
            {
                localization:
                    {
                        referralSidebarDetailsAction: "Refer a Friend",
                        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

                        referralRegisterHeading: "Give $15, Get $15",
                        referralRegisterFormDetails: "Submit your email to get started.",
                        referralRegisterFormEmail: "Enter your email...",
                        referralRegisterFormSubmit: "Next",
                        referralRegisterDetails: "Give your friends $15 off on their first order of $35 or more and get $15 in points for each successful referral.",

                        referralReferHeading: "Give $15, Get $15",
                        referralReferFormEmails: "Your friends’ emails (separated by commas)",
                        referralReferFormSubmit: "Send",
                        referralReferFormDetails: "Let's get started! Enter your friends' email addresses below",
                        referralReferFormEmailsDetails: "",
                        referralReferDetails: "Give your friends $15 off on their first order of $35 or more and get $15 in points for each successful referral.",
                        referralReferMediaDetails: "",

                        referralShareFacebook: "Share",
                        referralShareTwitter: "Tweet",
                        referralShareCopy: "Copy Link",
                        referralShareMessenger: "Message",
                        referralShareSMS: "SMS",

                        referralThanksHeading: "Thanks for Referring!",
                        referralThanksDetails: "Remind your friends to check their emails.",

                        referralCopyHeading: "",
                        referralCopyButton: "Copy Link",
                        referralCopyDetails: "Copy link and share with your friends."
                    }
            },
        initializeReferralCode: function(containerSelector) {
            if($(containerSelector).length > 0) {
                $(containerSelector).append('<div class="swell-referral-register"> <h2 class="swell-referral-heading"><span class="refer-friend-heading">'+SwellConfig.Referral.opts.localization.referralSidebarDetailsAction+'</span>'+SwellConfig.Referral.opts.localization.referralRegisterHeading+'</h2> <p class="swell-referral-details">'+SwellConfig.Referral.opts.localization.referralRegisterDetails+'</p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details">'+SwellConfig.Referral.opts.localization.referralRegisterFormDetails+'</p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="'+SwellConfig.Referral.opts.localization.referralRegisterFormEmail+'"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" name="swell-referral-register-submit" id="swell-referral-register-submit">'+SwellConfig.Referral.opts.localization.referralRegisterFormSubmit+'</button> </li> </ul> </div> </form> </div> </div>');
                $(containerSelector).append('<div class="swell-referral-refer"> <h2 class="swell-referral-heading"> <span class="refer-friend-heading-popup">Want to refer a friend?</span> <span class="refer-friend-heading">'+SwellConfig.Referral.opts.localization.referralSidebarDetailsAction+'</span> '+SwellConfig.Referral.opts.localization.referralReferHeading +'</h2> <p class="swell-referral-details">'+ SwellConfig.Referral.opts.localization.referralReferDetails+'</p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details">'+SwellConfig.Referral.opts.localization.referralReferFormDetails+'</p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="'+SwellConfig.Referral.opts.localization.referralReferFormEmails+'"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit">'+SwellConfig.Referral.opts.localization.referralReferFormSubmit+'</button> </li> </ul> </div> </form> </div> <div class="swell-referral-copy-holder"> <p class="copy-detail"><span class="swell-copy-link swell-referral-link" id="swell-copy-link" ></span></p> <a href="javascript:void(0)" data-clipboard-target="#swell-copy-link" id="copy-link-button" class="copy-btn">Copy Link</a> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-icon-facebook-share-mob" aria-hidden="true"></i>'+SwellConfig.Referral.opts.localization.referralShareFacebook+' </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-icon-sms-mob" aria-hidden="true"></i>'+SwellConfig.Referral.opts.localization.referralShareSMS+' </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-icon-fb-message-mob" aria-hidden="true"></i>'+SwellConfig.Referral.opts.localization.referralShareMessenger+' </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-icon-tweet-mob" aria-hidden="true"></i>'+ SwellConfig.Referral.opts.localization.referralShareTwitter+' </div> </li>  </ul> </div> </div>');
                $(containerSelector).append('<div class="swell-referral-thanks"> <span class="swell-referral-back-link swell-referral-thanks-close"></span> <h2 class="swell-referral-heading">'+SwellConfig.Referral.opts.localization.referralThanksHeading+'</h2> <p class="swell-referral-details">'+SwellConfig.Referral.opts.localization.referralThanksDetails +'</p> </div>');
            }
        },
        initializeReferral: function () {
            if(spapi.customer.email) {
                $(".swell-referral-refer").show();
            }
            else {
                $(".swell-referral-register").show();
            }
        },
        initializeReferralProcess: function () {
            //referral register step
            $("body").on("click", "#swell-referral-register-submit", function(e) {
                e.preventDefault();
                var customersInput = $("#swell-referral-register-email");
                onSuccess = function() {
                    $(".swell-referral-register").hide();
                    $(".swell-referral-refer").show();
                    $(".refer-customer-error").remove();
                }
                onError = function() {
                    $(".refer-customer-error").remove();
                    $("#swell-referral-register-email").val('');
                    $(".swell-referral-form-list").before('<p class="refer-customer-error">Please enter valid email address</p>');
                }
                swellAPI.identifyReferrer(customersInput.val(), onSuccess, onError);
            });

            //referral refer step
            $("body").on("click", "#swell-referral-refer-submit", function(e) {
                e.preventDefault();
                var referredCustomersInput = $("#swell-referral-refer-emails");
                var emails = referredCustomersInput.val().split(",");
                var onSuccess = function() {
                    $(".swell-referral-refer").hide();
                    $("#swell-referral-refer-emails").val('');
                    $(".swell-referral-thanks").css("display","flex");
                    $(".refer-customer-error").remove();
                    swellAPI.refreshCustomerDetails(function() {
                        SwellConfig.Referral.populateRedemptionOffers();
                    });
                }
                var onError = function(error) {
                    $(".refer-customer-error").remove();
                    $("#swell-referral-refer-emails").val('');
                    if(error.message == "EMAILS_ALREADY_PURCHASED") {
                        $(".swell-referral-form-list").before('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
                    }
                    else {
                        $(".swell-referral-form-list").before('<p class="refer-customer-error">'+ error.message +'</p>');
                    }
                }
                swellAPI.sendReferralEmails(emails,onSuccess, onError);
            });

            //referral thanks step
            $("body").on("click", ".swell-referral-thanks-close", function() {
                $(".swell-referral-thanks").hide();
                $(".swell-referral-refer").show();
            });
        },
        populateRedemptionOffers: function () {
            if (spapi.authenticated) {
                var receipts = spapi.customer.referral_receipts;
                var email;
                var completed_at;
                var status;
                var rewards_points;
                $(".table-data").html("");
                if(receipts && receipts.length > 0) {
                    receipts.forEach(function (ref_receipts) {
                        email = ref_receipts.email;
                        completed_at = ref_receipts.completed_at;
                        rewards_points = spapi.activeReferralCampaign.reward_text;

                        if (completed_at){
                            status = "completed";
                        } else {
                            status = "pending";
                        }
                        $(".table-data").append("<tr> <td> " + email + "</td> <td>" + status + "</td></tr>");
                    });

                }
            }
        },
    };
}).call(this);

//campaigns
(function () {
    window.SwellConfig = window.SwellConfig || {};
    SwellConfig.Campaign = {
        opts: {
            templates: {
                campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="<%= campaign.icon %>"></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </li>',
                campaignHover: '<div class="swell-campaign-hover"> <div class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"><a href="/account/login" class="swell-link-login">Sign In</a></li> <span>or</span> <li class="swell-link"><a href="/account/register" class="swell-link-register">Sign Up</a></li> </ul> </div> </div>'
            }
        },
        customCampaign: function(containerSelector) {
            $(containerSelector +" .swell-campaign:nth-child(4)").after('<li class="swell-campaign"> <div class="swell-newsletter-content" id="swellNewsLetter"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="swell-rewards-icon-newsletter"></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">10 points</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">Subscribe to Newsletter</span> </div> </div> </li>');
        },
        completedCampaigns: function()
        {
            if(spapi.authenticated) {
                var customerPerks = spapi.customer.perks;
                customerPerks.forEach(function(perk) {
                    if(perk.completed) {
                        if(perk.campaign_id == 526349) {
                            checkNewsLetterCampaign = false;
                        }
                    }
                });
            }
        },
        campaignHover: function() {
            if (!spapi.authenticated) {
                spapi.$(document).off("click", ".swell-campaign-content, .swell-redemption-option-content");
                return $(".swell-campaign-content, .swell-newsletter-content, .swell-redemption-option-content").hover(function() {
                    return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
                }, function() {
                    return $(this).find(".swell-campaign-hover").remove();
                });
            }
        }
    };
}).call(this);

//redemptions
(function () {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Redemption = {
        appendRedemption: function(containerSelector) {
            var redemptions = spapi.activeRedemptionOptions;
            redemptions.forEach(function(redemption) {
                if(redemption.discount_type == "shopify_recharge_fixed_amount") {
                    $(containerSelector).append('<li class="swell-redemption-option"> <div class="swell-redemption-option-content swell-redemption-link" data-redemption-option-id="'+ redemption.id +'"> <div class="swell-redemption-option-cost">'+ redemption.name +'</div> <div class="swell-redemption-option-value">'+ redemption.cost_text +'</div> </div> </li>')
                }
            });
        }
    };
}).call(this);

// tiers
(function() {
    window.SwellConfig = window.SwellConfig || {};
    SwellConfig.Tier = {
        getCustomerTierRank: function() {
            var customer_tier, intro_tier, rank, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier && customer_tier.id) {
                rank = $.grep(tiers, function(e) {
                    return e.id === customer_tier.id;
                })[0].rank;
                return rank;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].rank;
                } else {
                    return null;
                }
            }
        },
        getCustomerTierId: function () {
            var customer_tier, intro_tier, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier) {
                return customer_tier.id;
            } else {
                intro_tier = $.grep(tiers, function (e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].id;
                } else {
                    return null;
                }
            }
        },
        getTierByRank: function (rank) {
            var tiers;
            tiers = spapi.activeVipTiers;
            return $.grep(tiers, function (e) {
                return e.rank === rank;
            })[0];
        },
        initializeCustomTierProperties: function() {
            spapi.activeVipTiers[0].level = "Level 1",
                spapi.activeVipTiers[0].name = spapi.activeVipTiers[0].name,
                spapi.activeVipTiers[0].spend = "Spend $"+((spapi.activeVipTiers[0].amount_spent_cents)/100)+" - $"+(((spapi.activeVipTiers[1].amount_spent_cents)/100)-1) + "<span>or</span> refer " + spapi.activeVipTiers[0].referrals_completed + "+ friends",
                spapi.activeVipTiers[0].benefit1 = "<span>- 1 point per $1 spent</span>",
                spapi.activeVipTiers[0].benefit2 = "",
                spapi.activeVipTiers[0].benefit3 = "",
                spapi.activeVipTiers[0].benefit4 = "",

                spapi.activeVipTiers[1].level = "Level 2",
                spapi.activeVipTiers[1].name = spapi.activeVipTiers[1].name,
                spapi.activeVipTiers[1].spend = "Spend $"+((spapi.activeVipTiers[1].amount_spent_cents)/100)+"-$"+(((spapi.activeVipTiers[2].amount_spent_cents)/100)-1) + "<span>or</span> refer " + spapi.activeVipTiers[1].referrals_completed + "+ friends",
                spapi.activeVipTiers[1].benefit1 = "<span>- 1.5 points per $1 spent</span>",
                spapi.activeVipTiers[1].benefit2 = "<span>- Early Access To Sales</span>",
                spapi.activeVipTiers[1].benefit3 = "",
                spapi.activeVipTiers[1].benefit4 = "",

                spapi.activeVipTiers[2].level = "Level 3",
                spapi.activeVipTiers[2].name = spapi.activeVipTiers[2].name,
                spapi.activeVipTiers[2].spend = "$"+(spapi.activeVipTiers[2].amount_spent_cents/100)+"+ <span>or</span> refer " + spapi.activeVipTiers[2].referrals_completed + "+ friends",
                spapi.activeVipTiers[2].benefit1 = "<span>- 2 points per $1 spent</span>",
                spapi.activeVipTiers[2].benefit2 = "<span>- Early Access To Sales</span>"
            spapi.activeVipTiers[2].benefit3 = "<span>- Early Access To New Products</span>"
            spapi.activeVipTiers[2].benefit4 = "<span>- Free Product Samples</span>"
        },
        initializeTiers: function(containerSelector) {
            if ($(containerSelector).length === 0) {
                return "";
            }
            tiers = spapi.activeVipTiers;
            var count = 0;
            tiers.forEach(function (tier) {
                $(containerSelector).append('<li data-tier-id="'+tier.id+'" class="list-items tier'+count+'"> <div class="swell-tier-status"></div> <div class="items-holder"> <span class="tier-level">'+ tier.level +'</span> <div class="items-heading-holder"> <div class="name">'+ tier.name +'</div> <div class="tier_spend">'+ tier.spend +'</div> </div> <span class="tier-perk">Perks</span> <ul class="point-holder"> <li>'+ tier.benefit1 +'</li> <li>'+ tier.benefit2 +'</li> <li>'+ tier.benefit3 +'</li> <li>'+ tier.benefit4 +'</li> </ul> </div> </li>');
                count++;
            });
            if(spapi.authenticated) {
                SwellConfig.Tier.setupCustomerTierStatus();
            }
        },
        setupCustomerTierStatus: function () {
            var toGoNext, next_tier, toGoNextReferrals;
            var last_tier = spapi.activeVipTiers.length;
            var last_tier_rank = SwellConfig.Tier.getTierByRank(last_tier - 1);
            if (spapi.customer.vip_tier) {
                var $customer_tier_id, $customer_tier_rank;
                customer_tier_id = SwellConfig.Tier.getCustomerTierId();
                customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();

                tiers = spapi.activeVipTiers;
                tiers.forEach(function (tier) {
                    if (tier.id == customer_tier_id) {
                        customer_tier = tier;
                    }
                });
                if (last_tier_rank.rank == customer_tier_rank) {
                    tiers.forEach(function (tier) {
                        if (tier.rank == customer_tier.rank) {
                            $("li[data-tier-id='" + tier.id + "'] .swell-tier-status").append("<span>Your Current Status</span>");
                            $("li[data-tier-id='" + tier.id + "']").addClass("customer-tier-status");
                        }
                    });
                } else {
                    next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
                    toGoNext = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents) / 100;
                    toGoNextReferrals = next_tier.referrals_completed - spapi.customer.vip_tier_stats.referrals_completed;
                    if(toGoNext < 0)
                    {
                        toGoNext = 0;
                    }
                    if(toGoNextReferrals < 0)
                    {
                        toGoNextReferrals = 0;
                    }
                    tiers.forEach(function (tier) {
                        if (tier.rank == customer_tier.rank) {
                            $("li[data-tier-id='" + tier.id + "'] .swell-tier-status").append("<span>Your Current Status</span>");
                            $("li[data-tier-id='" + next_tier.id + "'] .swell-tier-status").append("<span class='spend_more'>Spend $" + toGoNext + " more or <br />make "+ toGoNextReferrals +" referrals to earn "+next_tier.name+" tier</span>");
                            $("li[data-tier-id='" + tier.id + "']").addClass("customer-tier-status");
                        }
                    });
                }
            }
            else {
                next_tier = SwellConfig.Tier.getTierByRank(0);
                toGoNext = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents) / 100;
                toGoNextReferrals = next_tier.referrals_completed - spapi.customer.vip_tier_stats.referrals_completed;
                if(toGoNext < 0)
                {
                    toGoNext = 0;
                }
                if(toGoNextReferrals < 0)
                {
                    toGoNextReferrals = 0;
                }
                $("li[data-tier-id='"+ next_tier.id +"'] .swell-tier-status").append("<span class='spend_more'>Spend $" + toGoNext + " more or <br />make "+ toGoNextReferrals +" referrals to earn "+next_tier.name+"</span>");
            }
        },
        setupSlick: function(containerSelector) {
            $(containerSelector).slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToScroll:1,
                slidesToShow: 3,
                prevArrow: false,
                nextArrow: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        }
    }
}).call(this);
